import { createActionThunk } from "redux-thunk-actions";

import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  CONTRIBUTE_GRAB_TEXT,
  CONT_BARCODE_READ,
  CONT_INITIALIZATION,
  CONT_SEND_DATA,
  CONT_CLEAR,
  CONT_RESTAURANT_ADD_IMAGE,
  CONT_RESTAURANT_SUBMIT,
  CONT_RESTAURANT_DEL_IMAGE,
  CONTRIBUTE_CATEGORY_SELECTED,
  CHECK_IS_DRAFT_DIRTY,
  CLEAR_CONT_DIRTY_DRAFT,
} from "./constant";
import {
  search as searchService,
  getDetail as getDetailService,
  barcodeService,
} from "../services/AutocompleteService";
import {
  sendImage,
  barcode,
  submitData,
  restaurantCont,
  getBarcode,
} from "../services/ContributeService";
// const initialization = () => {
//   return (dispatch) => {
//     dispatch({
//       type: CONT_INITIALIZATION,
//     });
//   };
// };
const initialization = createActionThunk(CONT_INITIALIZATION, (data) => {
  return { data };
});
export const barcodeSearch = (file, cat = "02") => {
  return async (dispatch) => {
    dispatch({
      type: getStarted(CONT_BARCODE_READ),
    });
    try {
      let data = await getBarcode(file, cat);
      try {
        let data1 = await barcodeService(data.barcode, cat);
        if (data1.message) {
          alert(data1.message);
        }
        dispatch({
          type: getSucceeded(CONT_BARCODE_READ),
          data: data1,
        });
      } catch (e) {
        if (e.message === "Resource not found") {
          dispatch({
            type: getSucceeded(CONT_BARCODE_READ),
            data: { is_ref: false, upc: data.barcode },
          });
        } else {
          dispatch({
            type: getFailed(CONT_BARCODE_READ),
            upc: data.barcode,
            data: e,
          });
        }
      }
    } catch (e) {
      dispatch({
        type: getFailed(CONT_BARCODE_READ),
        data: e,
      });
    }
  };
};

const grabText = createActionThunk(
  CONTRIBUTE_GRAB_TEXT,
  async (file, part, barcode) => {
    try {
      let data = await sendImage(file, part, barcode);
      return { data, part };
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : JSON.stringify(error);
      return { errorMessage, part };
    }
  }
);

const sendData = createActionThunk(
  CONT_SEND_DATA,
  async (data, barcode, category) => {
    data = await submitData(data, barcode, category);
    return { data };
  }
);
const clear = () => {
  return (dispatch) => {
    dispatch({
      type: CONT_CLEAR,
    });
  };
};
const checkIsDraftDirty = () => {
  return (dispatch) => {
    dispatch({
      type: CHECK_IS_DRAFT_DIRTY,
    });
  };
};
const clearDirtyDraft = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_CONT_DIRTY_DRAFT,
    });
  };
};
// const restAddImg = createActionThunk(
//   CONT_RESTAURANT_ADD_IMAGE,
//   (name, file) => {
//     return { name, file };
//   }
// );
const restAddImg = createActionThunk(
  CONT_RESTAURANT_ADD_IMAGE,
  async (name, file) => {
    try {
      let data = await sendImage(file, name, 1234);
      return { name, file };
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : JSON.stringify(error);
      return { name, errorMessage, file };
    }
  }
);

const restSubmit = createActionThunk(CONT_RESTAURANT_SUBMIT, async (data) => {
  return await restaurantCont(data);
});
const restDelImg = createActionThunk(
  CONT_RESTAURANT_DEL_IMAGE,
  (name, file) => {
    return { name, file };
  }
);
const contCategorySelected = (value, data) => {
  return (dispatch) => {
    dispatch({
      type: CONTRIBUTE_CATEGORY_SELECTED,
      value,
      data,
    });
  };
};
export default {
  grabText,
  barcodeSearch,
  initialization,
  sendData,
  clear,
  restAddImg,
  restSubmit,
  restDelImg,
  contCategorySelected,
  checkIsDraftDirty,
  clearDirtyDraft,
};



// WEBPACK FOOTER //
// ./src/actions/contributeActions.js